import React from 'react';
import classnames from 'classnames';
import { URLS, Url } from '@wix/da-url';
import { useTranslation } from 'react-i18next';
import { BiEventType, ReferralType } from '../../../biLogger/constants';
import UserMenuAvatar from './UserMenuAvatar';
import CoreIconSmall from '../../../Icons/CoreIconSmall';
import StandardMenu from '../../../Dropdown/MenuPreset/StandardMenu';
import { getMatureToggle, getThemeToggle } from './menuItemHelpers';
import { useFlag } from '../../../redux/flags/hooks';
import BiSpan from '../../../biLogger/Components/BiSpan';
import s from './UserMenu.scss';
var LoggedOutUserMenu = function (_a) {
    var hideNotificationCount = _a.hideNotificationCount, isUserMenuOpened = _a.isUserMenuOpened, onToggleUserMenu = _a.onToggleUserMenu, theme = _a.theme, matureContent = _a.matureContent, toggleMature = _a.toggleMature, toggleTheme = _a.toggleTheme, disableThemeSwitcher = _a.disableThemeSwitcher;
    var t = useTranslation().t;
    var watchJoin = useFlag('join_to_watch');
    var tabIndex = isUserMenuOpened ? 0 : -1;
    var items = [
        {
            className: s['top-group'],
            items: [
                {
                    componentClass: BiSpan,
                    label: (React.createElement("div", { className: s['two-side-label'] },
                        React.createElement("span", { className: s['anon-hello'] }, t('siteHeaderMobile.userMenu.hello')),
                        React.createElement(UserMenuAvatar, { onToggleUserMenu: onToggleUserMenu, isUserMenuOpened: isUserMenuOpened, tabIndex: tabIndex }))),
                },
            ],
        },
        {
            className: s['group'],
            items: [
                {
                    label: t('siteHeaderMobile.userMenu.signIn'),
                    link: Url.loginLink(),
                    biData: {
                        evid: BiEventType.TOP_NAV_MENU_CLICK,
                        link_url: Url.loginLink(),
                        menu_item: 'login',
                        menu_name: 'profile',
                    },
                    tabIndex: tabIndex,
                },
                {
                    label: t('siteHeaderMobile.userMenu.join'),
                    link: Url.joinLink(watchJoin ? 'topnav' : undefined),
                    biData: {
                        evid: BiEventType.REDIRECT_TO_LOGIN,
                        referral_info: ReferralType.HEADER,
                    },
                    tabIndex: tabIndex,
                },
                {
                    label: (React.createElement("div", { className: classnames(s['two-side-label'], s['buy-core-label']) },
                        React.createElement("span", null, t('siteHeaderMobile.userMenu.buyCoreMembership')),
                        React.createElement("span", null,
                            React.createElement(CoreIconSmall, { className: s['core-icon'] })))),
                    link: URLS.CORE_MEMBERSHIP,
                    tabIndex: tabIndex,
                },
                !disableThemeSwitcher && getThemeToggle(theme, toggleTheme, t),
                getMatureToggle(!!matureContent, toggleMature, t),
            ],
        },
        {
            className: s['group'],
            items: [
                {
                    label: t('siteHeader.helpAndFAQ'),
                    link: URLS.HELP,
                    biData: {
                        evid: BiEventType.TOP_NAV_MENU_CLICK,
                        link_url: URLS.HELP,
                        menu_item: 'help',
                        menu_name: 'profile',
                    },
                    tabIndex: tabIndex,
                },
                {
                    label: t('siteHeader.userMenu.termsOfService'),
                    link: URLS.TOS,
                    biData: {
                        evid: BiEventType.TOP_NAV_MENU_CLICK,
                        link_url: URLS.TOS,
                        menu_item: 'tos',
                        menu_name: 'profile',
                    },
                    tabIndex: tabIndex,
                },
                {
                    label: t('siteHeader.userMenu.privacyPolicy'),
                    link: URLS.PRIVACY,
                    biData: {
                        evid: BiEventType.TOP_NAV_MENU_CLICK,
                        link_url: URLS.PRIVACY,
                        menu_item: 'privacy_policy',
                        menu_name: 'profile',
                    },
                    tabIndex: tabIndex,
                },
            ],
        },
    ].filter(function (item) { return item; });
    return (React.createElement(StandardMenu, { id: "site-header-user-menu", role: "dialog", lightText: true, className: s['user-menu'], itemClassName: s['user-menu-item'], groupClassName: s['user-menu-group'], items: items }));
};
LoggedOutUserMenu.displayName = 'LoggedOutUserMenu';
export default LoggedOutUserMenu;
//# sourceMappingURL=LoggedOutUserMenu.js.map